import { render, staticRenderFns } from "./ShippingView.vue?vue&type=template&id=4dccb8fa&"
import script from "./ShippingView.vue?vue&type=script&lang=js&"
export * from "./ShippingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dccb8fa')) {
      api.createRecord('4dccb8fa', component.options)
    } else {
      api.reload('4dccb8fa', component.options)
    }
    module.hot.accept("./ShippingView.vue?vue&type=template&id=4dccb8fa&", function () {
      api.rerender('4dccb8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/battery-store/ShippingView.vue"
export default component.exports